import React from "react"
import { Row, Col, Card, CardBody, Button } from "reactstrap"
import { Link } from "react-router-dom"
import logo from "../../assets/images/logo-dark.png"

const QuickLink = ({ to, color, icon, label }) => (
  <Link to={to} className="text-decoration-none">
    <Button color="light" className="w-100 mb-2 text-start d-flex align-items-center gap-2 shadow-sm" style={{ borderLeft: `4px solid ${color}` }}>
      <i className={`bx ${icon} font-size-18`} style={{ color }}></i>
      <span className="fw-medium text-dark">{label}</span>
    </Button>
  </Link>
)

const WelcomeComp = () => {
  let getData = localStorage.getItem("authUser")
  let user = null
  try {
    user = JSON.parse(getData)
  } catch {
    user = { NameSurname: "Admin", GsmNumber: "", Email: "" }
  }

  const today = new Date().toLocaleDateString("tr-TR", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  })

  return (
    <React.Fragment>
      <Card className="overflow-hidden h-100">
        <div className="bg-primary bg-soft">
          <Row>
            <Col xs="7">
              <div className="text-primary p-3">
                <h5 className="text-primary">Hoşgeldiniz !</h5>
                <p className="mb-0">{today}</p>
              </div>
            </Col>
            <Col xs="5" className="align-self-end">
              <img src={logo} alt="" className="img-fluid" style={{ opacity: 0.6 }} />
            </Col>
          </Row>
        </div>
        <CardBody className="pt-0">
          <Row className="align-items-center">
            <Col sm="12">
              <div className="avatar-md profile-user-wid mb-3 mt-n5">
                <div className="avatar-title rounded-circle bg-light border border-2 border-white text-primary font-size-24">
                  <i className="bx bxs-user"></i>
                </div>
              </div>
              <h5 className="font-size-16 text-truncate">{user?.NameSurname || "Admin"}</h5>
              <p className="text-muted mb-2 text-truncate">{user?.Email || user?.GsmNumber || ""}</p>
              <span className="badge bg-success font-size-11">Çevrimiçi</span>
            </Col>
          </Row>

          <hr className="my-3" />

          <h6 className="font-size-13 text-muted text-uppercase mb-3">Hızlı Erişim</h6>
          <QuickLink to="/projects" color="#556ee6" icon="bx-box" label="Ürünler" />
          <QuickLink to="/recipes" color="#34c38f" icon="bx-book" label="Tarifler" />
          <QuickLink to="/news" color="#f46a6a" icon="bx-news" label="Haberler" />
          <QuickLink to="/slider" color="#f1b44c" icon="bx-slideshow" label="Slider" />
          <QuickLink to="/usersList" color="#50a5f1" icon="bx-user" label="Kullanıcılar" />
        </CardBody>
      </Card>
    </React.Fragment>
  )
}
export default WelcomeComp
